import ButtonSecondaryEllipse from './ButtonSecondaryEllipse';

export default ButtonSecondaryEllipse;
